import { render, staticRenderFns } from "./security-setting.vue?vue&type=template&id=1e351d32&"
import script from "./security-setting.vue?vue&type=script&lang=js&"
export * from "./security-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports